import { useEffect, useState } from 'react';
import CardLayout from '../../../../components/common/CardLayout';
import { getUnidade } from '../../../../funcs';
import apiUnidade from '../../../../services/apis/apiUnidade';
import useToast from '../../../../hooks/useToast';

export default function ListaUnidadeDetalhes({
}) {

	const { sucesso, erro } = useToast();
	const [form, setForm] = useState({
		diasDeTrabalhoMes: 0,
		horasTrabalhadasDia: 0,
		tensao: 0,
		fatorPotencia: 0,
	});

	const send = async (e) => {
		e.preventDefault();
		const unidade = getUnidade();

		const data = {
			...form,
			nome: unidade.nome,
			tipoUnidade: unidade.tipoUnidade,
		}
		
		try {
			await apiUnidade.postApiDetalhes(data);
			sucesso("Configuração de unidade salva com sucesso!");
		} catch (error) {
			erro("Erro ao salvar configuração de unidade");
		}
	}

	const handleNumericValue = (n) => {
		if (n.trim() === "") {
			return "";
		} else {
			return parseFloat(n);
		}
	}

	useEffect(() => {
		(async () => {
			try {
				const res = await apiUnidade.findAsync();
				setForm(res.data);
			} catch (error) {
				console.error(error.message);
			}
		})()
	},[]);

	return (
		<div className='flex justify-center w-128 mt-[50px]'>
			<CardLayout>
				<h1 className='font-bold text-center text-[30px]'>Configuração</h1>
				<form className="w-full flex justify-around my-5 px-5 flex-wrap gap-5" onSubmit={(e) => send(e)}>
					<div className="flex flex-col justify-end">
						<label
							htmlFor="diasDeTrabalhoMes"
							className="text-[14px] mb-2 pl-1"
						>
							Dias trabalhados no mês{' '}
						</label>
						<input
							id="diasDeTrabalhoMes"
							name="diasDeTrabalhoMes"
							type="number"
							placeholder="dias de trabalho do mês"
							className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
							value={form.diasDeTrabalhoMes}
							onChange={(e) =>
								setForm({
									...form,
									diasDeTrabalhoMes: handleNumericValue(e.target.value),
								})
							}
							required
						/>
					</div>
					<div className="flex flex-col justify-end">
						<label
							htmlFor="horasTrabalhadasDia"
							className="text-[14px] mb-2 pl-1"
						>
							Horas trabalhadas no dia{' '}
						</label>
						<input
							id="horasTrabalhadasDia"
							name="horasTrabalhadasDia"
							type="number"
							placeholder="dias de trabalho do mês"
							className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
							value={form.horasTrabalhadasDia}
							onChange={(e) =>
								setForm({
									...form,
									horasTrabalhadasDia: handleNumericValue(e.target.value),
								})
							}
							required
						/>
					</div>
					<div className="flex flex-col justify-end">
						<label
							htmlFor="tensao"
							className="text-[18px] mb-2 pl-1"
						>
							Tensão{' '}
						</label>
						<input
							id="tensao"
							name="tensao"
							type="number"
							placeholder="insira a tensão"
							className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
							value={form.tensao}
							onChange={(e) =>
								setForm({
									...form,
									tensao: handleNumericValue(e.target.value),
								})
							}
							required
						/>
					</div>
					<div className="flex flex-col justify-end">
						<label
							htmlFor="fatorPotencia"
							className="text-[18px] mb-2 pl-1"
						>
							Fator de Potência{' '}
						</label>
						<input
							id="fatorPotencia"
							name="fatorPotencia"
							type="number"
							placeholder="insira o fator de potência"
							className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
							value={form.fatorPotencia}
							onChange={(e) =>
								setForm({
									...form,
									fatorPotencia: handleNumericValue(e.target.value),
								})
							}
							required
						/>
					</div>
					<button 
						className="mt-5 sm:mt-0 px-4 py-2 bg-accent/70 text-white rounded-md hover:bg-accent border-slate-800 border-2 transition-all duration-200 ease-in-out"
					>
						Salvar
					</button>
				</form>
			</CardLayout>
		</div>
	);
}
